module.exports = __webpack_public_path__ + "img/camara.581144b4.svg";